import { useEffect, useState } from 'react';
import styles from '../../styles/components/input-container.module.scss';
import classNames from 'classnames';

export default function RadioAndLabel(props) {
  const [classes, setClasses] = useState(
    props.className
      ? styles.inputContainer + ' ' + props.className
      : styles.inputContainer
  );
  const layoutType = props.layout ?? 'list';

  // const [tipoFecha, setTipoFecha] = useState(false);

  useEffect(() => {
    if (props.className) {
      setClasses(styles.inputContainer + ' ' + props.className);
    }
  }, [props.className]);

  // useEffect(() => {
  //   if (props.tipoFecha) {
  //     setTipoFecha(props.tipoFecha);
  //   }
  // }, [props.tipoFecha]);

  return (
    <div
      aria-busy="true"
      role="radiogroup"
      id={props.name + 'rg'}
      aria-labelledby={props.name + 'rgl'}
      className={classes}
    >
      <label
        className={props.showRequiredMark ? 'required' : null}
        id={props.name + 'rgl'}
      >
        {props.label}
      </label>

      {props.description && <p>{props.description}</p>}

      {props.options && (
        <div className={styles[layoutType]}>
          {props.options.map((option, key) => {
            // const isDisabled =
            // option.value === 2 && props.tipoFecha === 2 ? true : false;
            return (
              <>
                {
                  <label
                    key={key}
                    id={props.name + 'ri' + key}
                    className={classNames(
                      'radioContainer',
                      props.radioSize === 'small' ? 'small' : null
                    )}
                    style={{
                      cursor: option.disable ? 'not-allowed' : 'pointer',
                      opacity: option.disable ? 0.6 : 1,
                    }}
                  >
                    <input
                      checked={Number(props.value) === option.value}
                      name={props.name}
                      onChange={props.onChange}
                      type="radio"
                      disabled={
                        option.disable !== null ? option.disable : false
                      }
                      value={option.value}
                    />
                    <span>{option.name}</span>
                  </label>
                }
                <p>{option.description} </p>
              </>
            );
          })}
        </div>
      )}
    </div>
  );
}
